const AnimationTypeEnum = {
  PROGRESS_BAR_ANIMATION: 'PROGRESS_BAR_ANIMATION',
  ANIMATION_START: 'ANIMATION_START',
  ANIMATION_STEP_SET: 'ANIMATION_STEP_SET',
  ANIMATION_FINISH: 'ANIMATION_FINISH',
  ANIMATION_UPDATE: 'ANIMATION_UPDATE',
  SELF_SERVE_BUILDER_FIELD_PLACEMENT_DONE_ANIMATION: 'SELF_SERVE_BUILDER_FIELD_PLACEMENT_DONE_ANIMATION',
  STATIC_BUILDER_SAVE_ANIMATION: 'STATIC_BUILDER_SAVE_ANIMATION',
};

export default AnimationTypeEnum;



// WEBPACK FOOTER //
// ./src-react/Animation/AnimationConstants.jsx